(() => {
  const configNode = document.getElementById('SpecialtyDtfUpsellConfig');
  let config;
  try {
    config = configNode ? JSON.parse(configNode.textContent) : window.SpecialtyDtfUpsellConfig;
  } catch (error) {
    console.error('[Specialty DTF config]', error);
    return;
  }
  if (!config || !config.baseProductId || !config.upgradeProductId) return;

  const upgradesBySku = new Map((config.upgradeVariants || []).map((variant) => [variant.sku, variant]));
  config.variants = {};
  (config.baseVariants || []).forEach((baseVariant) => {
    const numbers = String(baseVariant.title || '').match(/\d+/g) || [];
    const length = numbers.at(-1);
    if (!length) return;
    const reflective = upgradesBySku.get(`DTF-UP-R-${length}`);
    const glow = upgradesBySku.get(`DTF-UP-G-${length}`);
    if (!reflective || !glow) return;
    config.variants[String(baseVariant.id)] = {
      size: reflective.size || glow.size || baseVariant.title,
      reflective,
      glow
    };
  });

  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let renderTimer;

  const qs = (selector, scope = document) => scope.querySelector(selector);

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Cart could not be loaded.');
    return response.json();
  };

  const collectSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections }
    }));
    return [...new Set(sections.filter(Boolean))].slice(0, 5);
  };

  const request = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok || data?.status) {
      throw new Error(data?.description || data?.message || 'Cart update failed.');
    }
    return data;
  };

  const publishCart = (cart) => {
    if (window.theme?.pubsub?.publish && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate && cart?.sections) {
      window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart,
        target: null,
        line: null,
        name: null,
        source: 'specialty-dtf-upsell'
      });
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  };

  const money = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const copyProperties = (properties = {}) => ({ ...(properties || {}) });

  const createLinkId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return `dtf-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  };

  const findBaseByLink = (cart, linkId) => cart.items.find((item) =>
    Number(item.product_id) === Number(config.baseProductId) &&
    item.properties?._specialty_link_id === linkId
  );

  const upgradeLinesFor = (cart, baseKey, linkId = '') => cart.items.filter((item) => {
    if (Number(item.product_id) !== Number(config.upgradeProductId)) return false;
    if (linkId && item.properties?._specialty_link_id === linkId) return true;
    return item.properties?._specialty_base_key === baseKey;
  });

  const getFinish = (cart, base) => {
    const baseFinish = base.properties?.['SPECIALTY FINISH'];
    if (baseFinish) return baseFinish;
    const linkId = base.properties?._specialty_link_id || '';
    const line = upgradeLinesFor(cart, base.key, linkId)[0];
    return line?.properties?.['Specialty DTF'] || '';
  };

  const hideUpgradeLines = (cart) => {
    cart.items.forEach((item, index) => {
      if (Number(item.product_id) !== Number(config.upgradeProductId)) return;
      const drawerLine = document.getElementById(`CartDrawer-Item-${index + 1}`);
      const mainLine = document.getElementById(`CartItem-${index + 1}`);
      if (drawerLine) drawerLine.hidden = true;
      if (mainLine) mainLine.hidden = true;
    });
  };

  const findMount = (line) => {
    const drawerLine = document.getElementById(`CartDrawer-Item-${line}`);
    if (drawerLine) {
      const title = qs('.horizontal-product__title', drawerLine);
      return title?.parentElement || qs('.horizontal-product__details', drawerLine) || drawerLine;
    }

    const mainLine = document.getElementById(`CartItem-${line}`);
    if (mainLine) {
      const title = qs('.cart__item-title', mainLine);
      return title?.parentElement || qs('td', mainLine) || mainLine;
    }

    return null;
  };

  const cardHtml = (base, variantConfig, activeFinish, currency) => {
    const reflective = variantConfig.reflective;
    const glow = variantConfig.glow;
    const isReflective = activeFinish === reflective.label;
    const isGlow = activeFinish === glow.label;

    return `
      <div class="specialty-dtf-upsell__header">
        <strong class="specialty-dtf-upsell__title">${escapeHtml(config.title)}</strong>
        <span class="specialty-dtf-upsell__size">${escapeHtml(variantConfig.size)}</span>
      </div>
      <div class="specialty-dtf-upsell__prompt">${escapeHtml(config.chooseOptions)}</div>
      <div class="specialty-dtf-upsell__choices" role="group" aria-label="${escapeHtml(config.title)}">
        <button type="button" class="specialty-dtf-upsell__choice${isReflective ? ' is-active' : ''}" data-specialty-finish="reflective" data-base-key="${escapeHtml(base.key)}" data-base-variant="${base.variant_id}" aria-pressed="${isReflective}">
          <span>${escapeHtml(reflective.label)}</span>
          <strong>+${money(reflective.price, currency)}</strong>
        </button>
        <button type="button" class="specialty-dtf-upsell__choice${isGlow ? ' is-active' : ''}" data-specialty-finish="glow" data-base-key="${escapeHtml(base.key)}" data-base-variant="${base.variant_id}" aria-pressed="${isGlow}">
          <span>${escapeHtml(glow.label)}</span>
          <strong>+${money(glow.price, currency)}</strong>
        </button>
      </div>
      ${activeFinish ? `<button type="button" class="specialty-dtf-upsell__remove" data-specialty-remove data-base-key="${escapeHtml(base.key)}">${escapeHtml(config.remove)}</button>` : ''}
    `;
  };

  const render = async () => {
    if (busy) return;
    try {
      const cart = await getCart();
      hideUpgradeLines(cart);
      document.querySelectorAll('.specialty-dtf-upsell').forEach((node) => node.remove());

      cart.items.forEach((item, index) => {
        if (Number(item.product_id) !== Number(config.baseProductId)) return;

        const variantConfig = config.variants[String(item.variant_id)];
        if (!variantConfig) return;

        const mount = findMount(index + 1);
        if (!mount) return;

        const card = document.createElement('div');
        card.className = 'specialty-dtf-upsell';
        card.dataset.baseKey = item.key;
        card.innerHTML = cardHtml(item, variantConfig, getFinish(cart, item), cart.currency || 'USD');
        mount.appendChild(card);
      });
    } catch (error) {
      console.error('[Specialty DTF]', error);
    }
  };

  const removeExisting = async (cart, baseKey, linkId = '', includeSections = false) => {
    const lines = upgradeLinesFor(cart, baseKey, linkId);
    if (!lines.length) return cart;

    const updates = {};
    lines.forEach((line) => { updates[line.key] = 0; });
    const body = { updates };
    if (includeSections) body.sections = collectSections();
    return request('cart/update.js', body);
  };

  const setFinish = async (baseKey, baseVariantId, finishKey) => {
    if (busy) return;
    busy = true;
    document.documentElement.classList.add('specialty-dtf-is-updating');

    try {
      let cart = await getCart();
      let base = cart.items.find((item) => item.key === baseKey && Number(item.product_id) === Number(config.baseProductId));
      const variantConfig = config.variants[String(baseVariantId)];
      const desired = variantConfig?.[finishKey];
      if (!base || !desired) return;

      const linkId = base.properties?._specialty_link_id || createLinkId();
      const currentLines = upgradeLinesFor(cart, base.key, linkId);

      if (currentLines.length) {
        cart = await removeExisting(cart, base.key, linkId, false);
        base = findBaseByLink(cart, linkId) || cart.items.find((item) => item.key === baseKey && Number(item.product_id) === Number(config.baseProductId));
      }

      if (!base) throw new Error('The gang sheet line could not be found.');

      const baseProperties = copyProperties(base.properties);
      baseProperties['SPECIALTY FINISH'] = desired.label;
      baseProperties._specialty_link_id = linkId;

      cart = await request('cart/change.js', {
        id: base.key,
        quantity: base.quantity,
        properties: baseProperties
      });

      const updatedBase = findBaseByLink(cart, linkId);
      if (!updatedBase) throw new Error('The upgraded gang sheet could not be identified.');

      const sections = collectSections();
      const added = await request('cart/add.js', {
        items: [{
          id: desired.id,
          quantity: updatedBase.quantity,
          properties: {
            'Specialty DTF': desired.label,
            '_specialty_link_id': linkId,
            '_specialty_base_key': updatedBase.key,
            '_specialty_base_variant_id': String(updatedBase.variant_id),
            '_specialty_sheet_size': variantConfig.size
          }
        }],
        sections
      });

      const fresh = await getCart();
      fresh.sections = added.sections || {};
      publishCart(fresh);
    } catch (error) {
      console.error('[Specialty DTF]', error);
    } finally {
      busy = false;
      document.documentElement.classList.remove('specialty-dtf-is-updating');
      scheduleRender();
    }
  };

  const clearFinish = async (baseKey) => {
    if (busy) return;
    busy = true;
    document.documentElement.classList.add('specialty-dtf-is-updating');

    try {
      let cart = await getCart();
      let base = cart.items.find((item) => item.key === baseKey && Number(item.product_id) === Number(config.baseProductId));
      if (!base) return;

      const linkId = base.properties?._specialty_link_id || '';
      cart = await removeExisting(cart, base.key, linkId, false);
      base = linkId ? findBaseByLink(cart, linkId) : cart.items.find((item) => item.key === baseKey && Number(item.product_id) === Number(config.baseProductId));
      if (!base) throw new Error('The gang sheet line could not be found.');

      const baseProperties = copyProperties(base.properties);
      delete baseProperties['SPECIALTY FINISH'];

      const updated = await request('cart/change.js', {
        id: base.key,
        quantity: base.quantity,
        properties: baseProperties,
        sections: collectSections()
      });
      publishCart(updated);
    } catch (error) {
      console.error('[Specialty DTF]', error);
    } finally {
      busy = false;
      document.documentElement.classList.remove('specialty-dtf-is-updating');
      scheduleRender();
    }
  };

  const reconcile = async () => {
    if (busy) return;
    try {
      const cart = await getCart();
      const updates = {};

      cart.items.forEach((line) => {
        if (Number(line.product_id) !== Number(config.upgradeProductId)) return;
        const linkId = line.properties?._specialty_link_id || '';
        const baseKey = line.properties?._specialty_base_key;
        const base = (linkId && findBaseByLink(cart, linkId)) || cart.items.find((item) => item.key === baseKey && Number(item.product_id) === Number(config.baseProductId));
        if (!base) updates[line.key] = 0;
        else if (line.quantity !== base.quantity) updates[line.key] = base.quantity;
      });

      if (Object.keys(updates).length) {
        busy = true;
        const updated = await request('cart/update.js', {
          updates,
          sections: collectSections()
        });
        publishCart(updated);
      }
    } catch (error) {
      console.error('[Specialty DTF reconcile]', error);
    } finally {
      busy = false;
      scheduleRender();
    }
  };

  const scheduleRender = () => {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, 80);
  };

  document.addEventListener('click', (event) => {
    const finishButton = event.target.closest('[data-specialty-finish]');
    if (finishButton) {
      event.preventDefault();
      setFinish(finishButton.dataset.baseKey, finishButton.dataset.baseVariant, finishButton.dataset.specialtyFinish);
      return;
    }

    const removeButton = event.target.closest('[data-specialty-remove]');
    if (removeButton) {
      event.preventDefault();
      clearFinish(removeButton.dataset.baseKey);
    }
  });

  document.addEventListener('cart:updated', () => {
    scheduleRender();
    window.setTimeout(reconcile, 120);
  });

  document.addEventListener('DOMContentLoaded', () => {
    scheduleRender();
    window.setTimeout(reconcile, 200);
  });
})();
